import React from "react";
import "../styles/LegalPages.css";

// ✅ المصدر الوحيد: صفحة الهبوط daress.app
const LEGAL_URLS = {
  privacy_policy: "https://daress.app/privacy-policy.html",
  terms_conditions: "https://daress.app/terms.html",
};

const LegalPages = () => {
  return (
    <div className="legal-container">
      <h2 className="legal-title">⚖️ الصفحات القانونية</h2>
      <p className="legal-subtitle">
        تجد الصفحات القانونية الرسمية لمنصة دارس على موقعنا الرئيسي. اضغط على
        الروابط أدناه لقراءتها.
      </p>

      <div className="legal-links-grid">
        <a
          href={LEGAL_URLS.privacy_policy}
          target="_blank"
          rel="noopener noreferrer"
          className="legal-link-card"
        >
          <div className="legal-link-icon">🛡️</div>
          <div className="legal-link-info">
            <h3>سياسة الخصوصية</h3>
            <p>كيف نجمع بياناتك ونحميها ونستخدمها.</p>
          </div>
          <span className="legal-link-arrow">←</span>
        </a>

        <a
          href={LEGAL_URLS.terms_conditions}
          target="_blank"
          rel="noopener noreferrer"
          className="legal-link-card"
        >
          <div className="legal-link-icon">📋</div>
          <div className="legal-link-info">
            <h3>شروط الاستخدام</h3>
            <p>شروط وأحكام استخدام منصة دارس.</p>
          </div>
          <span className="legal-link-arrow">←</span>
        </a>

        <a
          href="mailto:info@daress.app"
          className="legal-link-card"
        >
          <div className="legal-link-icon">📧</div>
          <div className="legal-link-info">
            <h3>تواصل معنا</h3>
            <p>info@daress.app</p>
          </div>
          <span className="legal-link-arrow">←</span>
        </a>
      </div>

      <div className="legal-note">
        <span>💡</span>
        <p>
          أي تحديث على الصفحات القانونية يظهر فوراً في جميع المنصات
          (التطبيق، الموقع، لوحة التحكم) لأنها تشير لمصدر واحد.
        </p>
      </div>
    </div>
  );
};

export default LegalPages;
